import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

//Public
import { PublicLayout } from "../components/layout/public/PublicLayout.jsx";
import { ConexPage } from "../pages/conex";
import { SupplierRegistration } from "../components/layout/public/suppliers/SupplierRegistration";

//Enum
import { RouterEnum } from "./RouterEnum";

//Private
import { PrivateLayout } from "../components/layout/private/PrivateLayout.jsx";
import { SearchUser } from "../components/layout/private/search_user_module/SearchUser.jsx";
import { PageNotFound } from "../components/layout/page404/PageNotFound";
import { AuthProvider } from "../context/AuthProvider";
import { LogoutPage } from "../pages/logout";
import { DashboardPage } from "../pages/dashboard";
import { OrderReportPage } from "../pages/order-report/ui/OrderReportPage.jsx";
import { UserCreatePage } from "../pages/user-create";
import { UserEditPage } from "../pages/user-edit";
import { UserProfilePage } from "../pages/user-profile";
import { CreateOrder } from "../components/layout/private/purchase_orders_module/create_order/CreateOrder";
import { BeneficiariesManagement } from "../components/layout/private/beneficiaries_management_module/BeneficiariesManagement";
import { CompanyReport } from "../components/layout/private/reports_module/report_company/CompanyReport";
import { Deliveries } from "../components/layout/private/deliveries_module/Deliveries";
import { SearchUserForDeliveries } from "../components/layout/private/deliveries_module/SearchUserForDeliveries";
import { EditDeliveryOrder } from "../components/layout/private/deliveries_module/EditDeliveryOrder";
import { ValidationSupervision } from "../components/layout/private/products_module/validation_supervision/ValidationSupervision";
import { AdminManagementPage } from "../pages/admin-management";
import { SearchUserForRenegociation } from "../components/layout/private/renegociation_module/SearchUserForRenegociation";
import { Renegociation } from "../components/layout/private/renegociation_module/Renegociation";
import { PaymentsMenu } from "../components/layout/private/payments_module/dsci-review/payments-menu/PaymentsMenu";
import { PaySuppliers } from "../components/layout/private/payments_module/suppliers/pay-suppliers/PaySuppliers";
import { BeneficiaryDeliveryReview } from "../components/layout/private/payments_module/dsci-review/beneficiary-review.jsx/BeneficiaryDeliveryReview";
import { ReviewDocuments } from "../components/layout/private/payments_module/dsci-review/review-documents/ReviewDocuments";
import {
    CreateCollectionAccount
} from "../components/layout/private/payments_module/suppliers/create-collection-account/CreateCollectionAccount";
import {ListAccountOfSuppliers} from "../components/layout/private/payments_module/fiduciary/list-account-suppliers/ListAccountOfSuppliers";
import {
    CollectionAccountDetails
} from "../components/layout/private/payments_module/fiduciary/collection-account-details/CollectionAccountDetails";
import { ProductUploadTechnical } from "../components/layout/private/products_module/validation_technical/product_upload_technical/ProductUploadTechnical";
import { ListProductsByConvocationPage } from "../pages/catalog-management";
import { EditProductsByConvocation } from "../pages/catalog-edit-products-by-convocation";
import { ProductPriceQuotesPage } from "../pages/product-price-quotes";
import { AlertedProductsPage } from "../pages/alerted-products";
import {
    ValidationEnvironmental
} from "../components/layout/private/products_module/validation_environmental/ValidationEnvironmental";
import { ReportByConvocation } from "../pages/catalog-report";
import { CreateSuppliers } from "../components/layout/private/management_module/suppliers/CreateSuppliers";
import { ConvocationList } from "../components/layout/private/management_module/convocation/ConvocationList";
import { ConvocationMenuTab } from "../components/layout/private/management_module/convocation/ConvocationMenuTab";
import {
    ListConciliation
} from "../components/layout/private/payments_module/conciliation/list-conciliation/ListConciliation";
import {
    DeliveriesInformation
} from "../components/layout/private/deliveries_module/deliveries-information-table/DeliveriesInformation";
import {
    ConciliationDetail
} from "../components/layout/private/payments_module/conciliation/conciliation-detail/ConciliationDetail";
import {
    SearchPaymentRequests
} from "../components/layout/private/payments_module/fiduciary/search_payment_requests/SearchPaymentRequests";
import {
    SearchBeneficiaryInformation
} from "../components/layout/private/beneficiaries_management_module/search_beneficiary_information/SearchBeneficiaryInformation";

//Guards
import {SupplierDocsGuard} from "../guards/SupplierDocsGuard";
import {RoleGuard} from "../guards/RoleGuard";

//Enum roles
import { RolesEnum } from "../helpers/GlobalEnum";

export const Routing = () => {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Routes>
                    <Route path={RouterEnum.Conex } element={ <ConexPage /> } />

                    <Route path="/" element={ <PublicLayout /> }>
                        <Route index element={ <Navigate to={RouterEnum.RouterAdmin} replace /> } />
                        <Route path={ RouterEnum.Login } element={ <Navigate to={RouterEnum.RouterAdmin} replace /> } />
                        <Route path={ RouterEnum.SupplierRegistration } element={ <SupplierRegistration /> } />
                    </Route>

                    <Route path={ RouterEnum.RouterAdmin } element={<PrivateLayout /> }>

                        {/* WHITELIST, lo que no necesita validación */}
                        <Route path={RouterEnum.EditSuppliers} element={<CreateSuppliers />} />
                        <Route path={ RouterEnum.Logout } element={ <LogoutPage /> }         />

                        {/* Guard */}
                        <Route element={<SupplierDocsGuard />}>
                            {/* Dashboard */}
                            <Route index element={ <DashboardPage /> } />

                            {/* Buscar usuario */}
                            <Route path={ RouterEnum.SearchUser }  element={ <SearchUser /> }  />
                            <Route path={ RouterEnum.SearchBeneficiaryInformation }  element={ <SearchBeneficiaryInformation /> }  />

                            {/* Renegociacion */}
                            <Route path={ RouterEnum.SearchUserForRenegociation }  element={ <SearchUserForRenegociation /> }  />
                            <Route path={ RouterEnum.Renegociation }  element={ <Renegociation /> }  />

                            {/* Ordenes */}
                            <Route path={ RouterEnum.CreateOrder }  element={ <CreateOrder /> }  />

                            {/* Entregas */}
                            <Route path={ RouterEnum.SearchUserForDeliveries }  element={ <SearchUserForDeliveries /> }  />
                            <Route path={ RouterEnum.Deliveries }  element={ <Deliveries /> }  />
                            <Route path={ RouterEnum.EditDeliveryOrder }  element={ <EditDeliveryOrder /> }  />
                            <Route path={ RouterEnum.DeliveryInformationAndTracking } element={ <DeliveriesInformation /> }  />

                            {/* Productos */}
                            <Route path={ RouterEnum.ListProductsByConvocation }  element={ <ListProductsByConvocationPage /> }  />
                            <Route path={ RouterEnum.ProductUpload }  element={ <ProductUploadTechnical /> }  />
                            <Route path={ RouterEnum.ProductsEnviromental }  element={ <ValidationEnvironmental /> }  />
                            <Route path={ RouterEnum.ProductPriceQuotes }  element={ <ProductPriceQuotesPage /> }  />
                            <Route path={ RouterEnum.ProductsSupervision }  element={ <ValidationSupervision /> }  />
                            <Route path={ RouterEnum.EditProductsByConvocation }  element={ <EditProductsByConvocation /> }  />
                            <Route path={ RouterEnum.ReportByConvocation }  element={ <ReportByConvocation /> }  />

                            {/* Productos Alertados: solo Admin, Supervisión, Implementación (Técnico), Líderes Técnicos (Agro/No Agro) y Sub Operativa */}
                            <Route element={<RoleGuard allowedRoles={[RolesEnum.ADMIN, RolesEnum.SUPERVISION, RolesEnum.TECHNICAL, RolesEnum.LIDER_TECNICO_AGRO, RolesEnum.LIDER_TECNICO_NO_AGRO, RolesEnum.SUB_OPERATIVA]} />}>
                                <Route path={ RouterEnum.AlertedProducts }  element={ <AlertedProductsPage /> }  />
                            </Route>

                            {/* Payments */}
                            <Route path={ RouterEnum.Payments }  element={ <PaymentsMenu /> }  />
                            <Route path={ RouterEnum.PaymentsRole }  element={ <BeneficiaryDeliveryReview /> }  />
                            <Route path={ RouterEnum.ReviewPaymentsBeneficiaryId }  element={ <ReviewDocuments /> }  />
                            <Route path={ RouterEnum.PaymentsSuppliersList }  element={ <PaySuppliers /> }  />
                            <Route path={ RouterEnum.CreateCollectionAccount }  element={ <CreateCollectionAccount /> }  />

                            {/* Fiduciary */}
                            <Route path={ RouterEnum.ListAccountOfSuppliers }  element={ <ListAccountOfSuppliers /> }  />
                            <Route path={ RouterEnum.CollectionAccountDetails }  element={ <CollectionAccountDetails /> }  />
                            <Route path={ RouterEnum.SearchSP }  element={ <SearchPaymentRequests /> }  />

                            {/* Conciliation */}
                            <Route path={ RouterEnum.ListConciliation }  element={ <ListConciliation /> }  />
                            <Route path={ RouterEnum.ConciliationDetail }  element={ <ConciliationDetail /> }  />

                            {/* Management */}
                            <Route path={ RouterEnum.Management } element={ <AdminManagementPage /> }  />
                            <Route path={ RouterEnum.CreateUsers }  element={ <UserCreatePage /> }  />
                            <Route path={ RouterEnum.EditUsers }  element={ <UserEditPage /> }  />
                            <Route path={ RouterEnum.EditUser }  element={ <UserProfilePage /> }  />
                            <Route path={ RouterEnum.CreateSuppliers }  element={ <CreateSuppliers /> }  />
                            <Route path={ RouterEnum.ConvocationList }  element={ <ConvocationList /> }  />
                            <Route path={ RouterEnum.CreateConvocation }  element={ <ConvocationMenuTab /> }  />
                            <Route path={ RouterEnum.CreateConvocationEdit }  element={ <ConvocationMenuTab /> }  />

                            {/* Reportes */}
                            <Route path={ RouterEnum.Reports }  element={ <BeneficiariesManagement /> }  />
                            <Route path={ RouterEnum.CompanyReport }  element={ <CompanyReport /> }  />
                            <Route path={ RouterEnum.OrderReport }  element={ <OrderReportPage /> }  />
                        </Route>
                    </Route>

                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    )
}
